import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div
                      className="col-md-12 center-column content-with-background"
                      id="content"
                    >
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">
                              Delivery Information
                            </h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-sections">
                                  {/* 1. United States Delivery */}
                                  <div className="pdh-policy-section">
                                    <ol start={1}>
                                      <li className="pdh-policy-section-title">
                                        United States Delivery
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        We offer the following delivery options
                                        for eligible orders within the United States:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          <strong>Standard Delivery:</strong>{" "}
                                          $5.95 (3-7 business days).
                                        </li>
                                        <li>
                                          <strong>Expedited Delivery:</strong>{" "}
                                          $12.95 (2-3 business days where available).
                                        </li>
                                        <li>
                                          <strong>Free Delivery:</strong>{" "}
                                          Available on eligible orders over $40.
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  {/* 2. International Delivery */}
                                  <div className="pdh-policy-section">
                                    <ol start={2}>
                                      <li className="pdh-policy-section-title">
                                        International Delivery
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        International delivery is available only
                                        to destinations shown at checkout.
                                        Times and costs vary by destination:
                                      </p>
                                      <ul className="pdh-policy-disc-list">
                                        <li>
                                          <strong>Canada:</strong> $15.00 (7-14
                                          business days).
                                        </li>
                                        <li>
                                          <strong>Other checkout destinations:</strong>{" "}
                                          from $25.00 (10-21 business days).
                                        </li>
                                      </ul>
                                      <p className="pdh-policy-text">
                                        Customs, duties, and local taxes may
                                        apply for international orders. These
                                        are the responsibility of the customer.
                                      </p>
                                    </div>
                                  </div>

                                  {/* 3. Order Tracking */}
                                  <div className="pdh-policy-section">
                                    <ol start={3}>
                                      <li className="pdh-policy-section-title">
                                        Order Tracking
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        Once your order has been dispatched, you
                                        will receive a shipping confirmation
                                        email containing a tracking number. You
                                        can use this tracking number to monitor
                                        the progress of your delivery.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="pdh-policy-section">
                                    <ol start={4}>
                                      <li className="pdh-policy-section-title">
                                        Processing and Delivery Estimates
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        Delivery estimates begin after order
                                        processing and are not guarantees.
                                        Weekends, holidays, weather, carrier
                                        disruption, customs review, and events
                                        outside our reasonable control can add
                                        time.
                                      </p>
                                      <p className="pdh-policy-text">
                                        If a material delay becomes known before
                                        dispatch, we may contact you with an
                                        updated estimate and any cancellation
                                        right required by applicable law.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="pdh-policy-section">
                                    <ol start={5}>
                                      <li className="pdh-policy-section-title">
                                        Address Changes and Delivery Problems
                                      </li>
                                    </ol>
                                    <div className="pdh-policy-section-content">
                                      <p className="pdh-policy-text">
                                        Check the delivery address before
                                        submitting your order and contact
                                        many@pawluna.art immediately about a
                                        mistake. We cannot promise a change after
                                        fulfillment begins, and carrier
                                        redirection may create a fee or delay.
                                      </p>
                                      <p className="pdh-policy-text">
                                        Report a parcel that is damaged, missing,
                                        marked delivered but not received, or
                                        returned to sender as soon as reasonably
                                        possible. Keep all packaging and provide
                                        photographs when damage is visible so we
                                        can review the matter with the carrier.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Delivery;
